import { defineStore } from "pinia";
// import url from "../axios/url";
// import axios from "axios";
import { AxiosClient } from "../axios/axios";
import router from "../router";
import { SaveToken , ClearToken, GetToken} from "@/helpers/encrypt";
export const useAuthStore = defineStore("authStore", {
  state: () => ({
    user: null,
    name: null,
    email: null,
    prvi: [],
    token: localStorage.getItem("token") || null,
    error: null,
    errors: {},
    isLoading: false,
  }),

  getters: {
    isLoggedIn: () => GetToken() != null,
  },
  actions: {
    //Clear errors Action Start
    async clearErrors() {
      this.error = "";
      this.errors = {};
    },
    //clear errors end start
    //Login Action Start
    async login(formData) {
      this.isLoading = true;

      return new Promise((resolve, reject) => {
        AxiosClient.post(`/login`, formData, {
          withCredentials: true,
        })
          .then(async (res) => {
            if (res.status === 201) {
              await SaveToken(res.data.token);
              resolve(res)
            }
          })
          .catch((error) => {
            this.isLoading = false;
            if (error?.response?.data?.errors) {
              this.errors = error.response.data.errors;
            } else if (error?.response?.data?.message) {
              this.error = error?.response?.data?.message;
            } else {
              this.error = "Login failed. Please try again.";
            }
            reject(error);
          });
      });
    },
    //Login Action End
    //Logout Action Start
    async logout() {
      // Clear the token and user data
      try {
          ClearToken();
        this.user = null;
        this.token = null;
        router.push({ name: "login" });
      } catch (error) {
        ClearToken();
        this.error = error?.response?.data?.message ?? "An error occurred";
        this.user = null;
        router.push({ name: "login" });
      }
    },
    //Logout Action End

    // Get User Action Start
    async getUser() {
      return new Promise((resolve, reject) => {
        AxiosClient.get(`usr`)
          .then((res) => {
            if (res.status === 201 || res.status === 200) {
              this.user = res?.data?.info;
              this.name = res?.data?.info?.name;
              this.email = res?.data?.info?.email;
              this.prvi = res?.data?.info?.abilities;
              resolve(res.data);
            }
          })
          .catch((error) => {
            if(error?.status === 401) {
              this.logout();
            }
            reject(error);
          });
      });
    },
    // Get User Action End


    // Get User Action Start
    async updatePassword(payload) {
      return new Promise((resolve, reject) => {
        AxiosClient.post(`usr`, payload)
          .then((res) => {
            if (res.status === 201 || res.status === 200) {
              resolve(res.data);
            }
          })
          .catch((error) => {
            if(error?.status === 401) {
              this.logout();
            }
            reject(error);
          });
      });
    },
    // Get User Action End


    // get privileges

    getPrivileges() {
      return new Promise((resolve, reject) => {
        AxiosClient.get(`v1/permissions`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // end of get privileges
  },
});
